import React from 'react'

import { ReactComponent as Close } from 'assets/icons/modal-closeNew.svg'

function ModalHeaderNew({ title, toggle, subTitle, showCloseButton = true, verifyCondition }) {
    return (
        <div className={`pt-6 pb-6 flex flex-top flex-between ${verifyCondition?"ptNew-0":""}`}>
            <div className="flex flex-column">
                <div className={`fw-600 c-primary-0 lpf-40`}>{title}</div>
                {subTitle && <div className="c-success-500 fs-3 mt-2">{subTitle}</div>}
            </div>
            {showCloseButton && (
                <div
                    style={{ borderRadius: '14px' }}
                    className={`px-1   flex flex-middle nmx-1 ${verifyCondition?" pt-1":"pb-1"}`}
                    onClick={toggle}
                >
                    <Close height={22} width={22} className=" c-pointer c-neutral-900" />
                </div>
            )}
        </div>
    )
}

export default ModalHeaderNew
